module.exports = __webpack_public_path__ + "static/media/biruxOro112.d92089e2.png";